import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { TExamsDetails } from 'src/app.type/examsDetails';

interface CbtRoundTableHeaderProps {
  examDetail: TExamsDetails[];
};

const CbtRoundTableHeader = ({ examDetail }: CbtRoundTableHeaderProps) => {
  const router = useRouter();
  const sorts = (router.query.sorts as string) || 'examDate,desc';

  const handleButtonClick = (sorts: 'examDate,desc' | 'examDate,asc') => {
    router.push({
      pathname: router.pathname,
      query: { ...router.query, sorts },
    }, undefined, { shallow: true });
  };

  return (
    <Header>
      <p>
        총 <span>{examDetail?.length}</span>회차
      </p>
      <div className="button-wrapper">
        <button
          className={sorts === 'examDate,desc' ? 'active' : ''}
          onClick={() => handleButtonClick('examDate,desc')}
        >
          최신 회차부터
        </button>
        <button
          className={sorts === 'examDate,asc' ? 'active' : ''}
          onClick={() => handleButtonClick('examDate,asc')}
        >
          1회차부터
        </button>
      </div>
    </Header>
  );
};

export default CbtRoundTableHeader;

const Header = styled.div`
  p {
    margin: 0;
    font-size: 18px;
    color: #333;
    font-weight: 500;

    @media ${({ theme }) => theme.device.mobile} {
      font-size: 16px;
    }

    span {
      color: #01a0ff;
    }
  }

  .button-wrapper {
    display: flex;
    margin: 24px 0 20px;
    gap: 37px;

    button {
      font-size: 16px;
      color: #888;
      font-weight: 500;
      position: relative;
      @media ${({ theme }) => theme.device.mobile} {
        font-size: 15px;
      }

      &.active {
        font-weight: 600;
        color: #01a0ff;
      }
      &::after {
        content: '';
        display: inline-block;
        width: 2px;
        height: 16px;
        background-color: #ddd;
        position: absolute;
        right: -18px;
        top: 50%;
        transform: translateY(-50%);
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
`;
